module.exports = __webpack_public_path__ + "img/NO917850984.3d65bbe1.png";